import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; 
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import logo from '../assets/images/logo.svg';
import passwordeye from '../assets/images/eye.svg';
import Footer from '../components/Footer';
import config from '../config/config';

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
    email: '', // Email added to form data
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // Function to extract token and email from the URL query params
  const getQueryParams = () => {
    const params = new URLSearchParams(location.search);
    return {
      token: params.get('token'),
      email: params.get('email'),
    };
  };

  // Extracting the parameters
  const { token, email } = getQueryParams();

  useEffect(() => {
    if (!token) {
      setErrorMessage('Invalid or missing token.');
    } else if (!email) {
      setErrorMessage('Invalid or missing email.');
    } else {
      // Set the email in the form data if token and email are valid
      setFormData((prevData) => ({ ...prevData, email }));
    }
  }, [token, email]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value, 
    }));
    setErrorMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }

    if (!token || !email) {
      setErrorMessage('No token or email provided, unable to reset password.');
      return;
    }

    try {
      const response = await fetch(`${config.baseURL}/reset-passwords`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
          email,
          password: formData.password,
          password_confirmation: formData.confirmPassword,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Password reset failed');
      }

      if (result.success === false) {
        setErrorMessage(result.message || 'Invalid token or email.');
      } else {
        setSuccessMessage('Password reset successful. Redirecting to login...');
        setTimeout(() => navigate('/Login'), 2000);
      }
    } catch (error) {
      console.error('Password reset failed:', error);
      setErrorMessage(error.message || 'An error occurred. Please try again.');
    }
  };

  return (
    <div>
      <div className="login_wrap resetpassword_wrap">
        <div className="login_wrap_container">
          <div className="right_login_box">
            <div className="img_content">
              <img src={logo} alt="logo" />
              <h4>Sign up to support your favorite creators</h4>
            </div>
          </div>
          <div className="left_login_box">
            <div className="login_box">
              <div id="form-container">
                <form id="signupForm" onSubmit={handleSubmit}>
                  <p className="p_sub_head">Reset your password</p>                  
             
                  <div className="mb-4 pwd_side position_relative">
                    <input 
                      type={showPassword ? "text" : "password"} 
                      className="form-control" 
                      id="password" 
                      placeholder="New Password" 
                      value={formData.password} 
                      onChange={handleChange} 
                      required
                    />
                    <label htmlFor="password" className="placeholder-label">New Password</label>
                    <img 
                      className="password-toggle" 
                      src={passwordeye} 
                      alt="Show Password" 
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>

                  <div className="mb-4 pwd_side position_relative"> 
                    <input 
                      type={showPassword ? "text" : "password"} 
                      className="form-control" 
                      id="confirmPassword" 
                      placeholder="Confirm Password" 
                      value={formData.confirmPassword}  
                      onChange={handleChange} 
                      required
                    />
                    <label htmlFor="confirmPassword" className="placeholder-label">Confirm Password</label>
                  </div>

                  {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}

                  {successMessage && (
                    <div className="alert alert-success" role="alert">
                      {successMessage}
                    </div>
                  )}

                  <div className="d-grid my-4 mb-0">
                    <button className="btn btn-primary" type="submit">Reset Password</button>
                  </div>
                </form>       
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPassword;
